var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoScotia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1178 15.1284H28.1123C21.265 15.1284 15.6265 20.1405 14.8904 26.5849H14.8884C13.8344 24.7385 13.2344 22.615 13.2344 20.3556C13.2344 13.2373 19.1902 7.46667 26.5373 7.46667H47.2544L40.1178 15.1284Z",
    fill: "#EC111A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0966 40.8717H28.1021C34.9494 40.8717 40.5884 35.8596 41.3235 29.4151H41.326C42.38 31.2615 42.98 33.385 42.98 35.6444C42.98 42.7627 37.0242 48.5333 29.6771 48.5333H8.95996L16.0966 40.8717Z",
    fill: "#EC111A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8211 28C38.8211 33.726 34.0243 38.3678 28.1068 38.3678C22.1894 38.3678 17.3926 33.726 17.3926 28C17.3926 22.274 22.1894 17.6323 28.1068 17.6323C34.0243 17.6323 38.8211 22.274 38.8211 28Z",
    fill: "#EC111A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoScotia);
export default __webpack_public_path__ + "static/media/LogoScotia.e61e85582062ba2de3c51ad76687a15f.svg";
export { ForwardRef as ReactComponent };